function isGroupConfig(config) {
    return !!(config === null || config === void 0 ? void 0 : config.rows);
}
function isGroupSchema(schema) {
    return typeof schema !== 'string';
}

export { isGroupConfig, isGroupSchema };
//# sourceMappingURL=utils.js.map
